import React, { useState } from "react";
import DatePicker from "../ui/datepicker";
import InputPesquisa from "../ui/InputPesquisa";
import ButtonExibir from "../ui/Button/ButtonExibir";
import ButtonLimpar from "../ui/Button/ButtonLimpar";
import Tabela from "./Tabela";
import TabelaRodape from "../ui/TabelaRodape";

// Importa o service
import { listarChamados } from "../Services/RelatorioChamado/listarChamados";

export default function RelatorioChamado() {
  const [dataInicial, setDataInicial] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [cliente, setCliente] = useState("");
  const [funcionario, setFuncionario] = useState("");

  // 🔹 NOVO ESTADO — STATUS (campo digitável)
  const [status, setStatus] = useState("");

  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 Paginação
  const [pagina, setPagina] = useState(1);
  const itensPorPagina = 10;

  // 🔍 Buscar no backend
  const handleExibir = async () => {
    setLoading(true);
    try {
      console.log("📊 Enviando filtros:", {
        dataInicial,
        dataFinal,
        cliente,
        funcionario,
        status,
      });

      const resposta = await listarChamados({
        dataInicial,
        dataFinal,
        cliente,
        funcionario,
        status,
      });

      if (resposta.status === "sucesso") {
        setDados(resposta.dados);
        setPagina(1);
      } else {
        alert("Erro: " + resposta.mensagem);
      }
    } catch (erro) {
      console.error("❌ Erro ao buscar chamados:", erro);
      alert("Erro ao buscar chamados: " + erro.message);
    } finally {
      setLoading(false);
    }
  };

  // 🧹 Limpar tudo
  const handleLimpar = () => {
    setDataInicial("");
    setDataFinal("");
    setCliente("");
    setFuncionario("");
    setStatus("");
    setDados([]);
    setPagina(1);
  };

  const handlePaginaChange = (novaPagina) => {
    if (novaPagina >= 1 && novaPagina <= Math.ceil(dados.length / itensPorPagina)) {
      setPagina(novaPagina);
    }
  };

  const indiceInicial = (pagina - 1) * itensPorPagina;
  const dadosPagina = dados.slice(indiceInicial, indiceInicial + itensPorPagina);

  return (
    <div className="p-8 text-slate-800">
      <h1
        className="text-3xl mb-6"
        style={{ color: "#454545", fontFamily: "Comfortaa, cursive" }}
      >
        Relatório de Chamados 📊
      </h1>

      {/* Card dos filtros */}
      <div
        className="bg-white px-6 py-5 border border-gray-200 flex flex-col gap-4"
        style={{
          borderRadius: "6px",
          boxShadow: "0 3px 10px rgba(0,0,0,0.12)",
        }}
      >
        {/* Botões */}
        <div className="flex justify-end gap-3 mb-2">
          <ButtonLimpar onClick={handleLimpar} />
          <ButtonExibir onClick={handleExibir} disabled={loading} />
        </div>

        {/* Filtros */}
        <div className="flex flex-wrap items-end justify-start gap-4">

          {/* Data inicial */}
          <div className="flex flex-col max-w-[220px] w-full">
            <label className="text-[13px] mb-[2px]" style={{ fontFamily: "Comfortaa, cursive", color: "#454545" }}>
              Data inicial
            </label>
            <DatePicker
              value={dataInicial}
              onChange={setDataInicial}
              placeholder="dd/mm/aaaa"
              className="h-[44px] w-full text-sm"
            />
          </div>

          {/* Data final */}
          <div className="flex flex-col max-w-[220px] w-full">
            <label className="text-[13px] mb-[2px]" style={{ fontFamily: "Comfortaa, cursive", color: "#454545" }}>
              Data final
            </label>
            <DatePicker
              value={dataFinal}
              onChange={setDataFinal}
              placeholder="dd/mm/aaaa"
              className="h-[44px] w-full text-sm"
            />
          </div>

          {/* Cliente */}
          <div className="flex flex-col max-w-[360px] w-full">
            <label className="text-[13px] mb-[2px]" style={{ fontFamily: "Comfortaa, cursive", color: "#454545" }}>
              Cliente
            </label>
            <InputPesquisa
              value={cliente}
              onChange={(e) => setCliente(e.target.value)}
              className="w-[340px]"
            />
          </div>

          {/* Técnico */}
          <div className="flex flex-col max-w-[260px] w-full">
            <label className="text-[13px] mb-[2px]" style={{ fontFamily: "Comfortaa, cursive", color: "#454545" }}>
              Técnico Responsável
            </label>
            <InputPesquisa
              value={funcionario}
              onChange={(e) => setFuncionario(e.target.value)}
            />
          </div>

          {/* ⭐ Campo Status (DIGITÁVEL) */}
          <div className="flex flex-col max-w-[220px] w-full">
            <label className="text-[13px] mb-[2px]" style={{ fontFamily: "Comfortaa, cursive", color: "#454545" }}>
              Status
            </label>
            <InputPesquisa
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              placeholder="Digite o status..."
            />
          </div>
        </div>
      </div>

      {/* Linha separadora */}
      <div className="mt-5 border-b-2 border-[#f95000]"></div>

      {/* Tabela */}
      <Tabela dados={dadosPagina} carregando={loading} />

      {/* Rodapé */}
      {dados.length > 0 && (
        <TabelaRodape
          total={dados.length}
          pagina={pagina}
          itensPorPagina={itensPorPagina}
          onPaginaChange={handlePaginaChange}
        />
      )}
    </div>
  );
}
